import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MobileMenu extends ThemeComponent {
    @Ref() backBtn !: HTMLElement[];
    @Ref() backBtnGrandchild !: HTMLElement[];
    @Ref() childOverlay !: HTMLElement;
    @Ref() childParent !: HTMLButtonElement[];
    @Ref() navlistTitle !: HTMLElement[];
    @Ref() grandchildListTitle !: HTMLElement[];
    @Ref() grandchild !: HTMLElement[];
    @Ref() grandchildTrigger !: HTMLButtonElement[];
    private open: string = '';
    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;

        // Use the private backing field to dispatch
        this._onOpenChange.dispatch(open);
    }
    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
        this.handleBackBtn();
        this.handleGrandchild();
        for (const childLink of this.childParent) {
            for (const title of this.navlistTitle) {
                title.innerHTML = childLink.value;
            }


        }
        for (const grandchildLink of this.grandchildTrigger) {
            for (const title of this.grandchildListTitle) {
                title.innerHTML = grandchildLink.value;
            }


        }
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openMenu();
    }

    handleBackBtn() {
        for(const btn of this.backBtn) {
            this.$listen( btn, 'click', () => {
                this.childOverlay.classList.add('closed');
                this.childOverlay.classList.remove('is-active');
                for (const childLink of this.childParent) {
                    this.$listen(childLink, 'click', () => {
                        this.childOverlay.classList.remove('closed');
                        for (const title of this.navlistTitle) {
                            title.innerHTML = childLink.value;
                        }

                    });
                }

            });
        }
        for (const btn of this.backBtnGrandchild) {
            this.$listen(btn, 'click', () => {
                for (const overlay of this.grandchild) {
                    overlay.classList.add('closed');
                    overlay.classList.remove('is-active');
                }
            });
        }

        for (const link of this.grandchildTrigger) {
            this.$listen(link, 'click', () => {
                this.childOverlay.classList.remove('closed');
                for (let i = 0; i < this.grandchildTrigger.length; i++) {
                    const title = this.grandchildListTitle[i];
                    const link = this.grandchildTrigger[i];
                    title.innerHTML = link.value;
                }
            });
        }

    }

    handleGrandchild() {
        for (let i = 0; i < this.grandchildTrigger.length; i++) {
            const link = this.grandchildTrigger[i];
            const list = this.grandchild[i];

            this.$listen(link, 'click', (e) => {
                e.preventDefault();
                list.classList.add('is-active');
            });
        }
    }


    /**
     * Open Side Cart.
     */
    openMenu() {
        document.addEventListener('openMenu', () => {
            this._onOpenChange.dispatch(this.open);
        });
    }
}
